import { render, staticRenderFns } from "./AudioSpace.vue?vue&type=template&id=4085ca4c&scoped=true"
import script from "./AudioSpace.vue?vue&type=script&lang=js"
export * from "./AudioSpace.vue?vue&type=script&lang=js"
import style0 from "./AudioSpace.vue?vue&type=style&index=0&id=4085ca4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4085ca4c",
  null
  
)

export default component.exports